<template>
    <v-container>
    <v-dialog  :value="this.value" @input="handleInput" width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">Ajuda para lista de filmes</span>
          </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="2">Icone</v-col>
                    <v-col>Significado</v-col>
                </v-row>
                <v-row>
                    <v-col cols="2">
                        <v-icon size="30">mdi-sort</v-icon>
                    </v-col>
                    <v-col>Menu de ordenação</v-col>
                </v-row>
                <v-row>
                    <v-col cols="2">
                        <v-icon>mdi-star-outline</v-icon>
                    </v-col>
                    <v-col>Ordenar primeiro quem tem mais estrelas.</v-col>
                </v-row>
                <v-row>
                    <v-col cols="2">
                        <v-icon>mdi-message-text-clock-outline</v-icon>
                    </v-col>
                    <v-col>Ordenar primeiro avaliado mais recenemente.</v-col>
                </v-row>
                <v-row>
                    <v-col cols="2">
                        <v-icon size="30">mdi-filter-minus-outline</v-icon>
                    </v-col>
                    <v-col>Menu de filtros</v-col>
                </v-row>
                <v-row>
                    <v-col cols="2">
                        <v-icon>mdi-television-classic</v-icon>
                    </v-col>
                    <v-col>Mostrar/Ocultrar Séries</v-col>
                </v-row>
                <v-row>
                    <v-col cols="2">
                        <v-icon>mdi-movie-outline</v-icon>
                    </v-col>
                    <v-col>Mostrar/Ocultrar Filmes</v-col>
                </v-row>
                <v-row>
                    <v-col cols="2">
                        <v-icon>mdi-star-off</v-icon>
                    </v-col>
                    <v-col>Mostrar/Ocultrar filmes que você já avaliou</v-col>
                </v-row>
            </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="handleInput(false)">ok</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
</template>
<script>
export default {
  name: 'AjudaFilmes',
  props: ['value'],
  data() {
    return {
      dialog: this.value,
    };
  },
  mounted() {
    // setInterval(() => { console.warn(this.dialog); }, 1000);
  },
  methods: {
    handleInput(e) {
      this.$emit('input', e);
    },
  },
};
</script>
